import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/solid";

export default function FormInput({
  label,
  name,
  value = "",
  onChange,
  placeholder,
  type = "text",
  required = false,
  error,
  additionalClass = "",
  prefix = null,
  icon = null,
  onFocus = () => {},
  showRequiredOrOptional = true,
  maxLength = 400,
  showMaxLength = false,
  max = null,
}) {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);

  const showCounter = !!maxLength && showMaxLength;
  const showEye = type === "password";
  const rightPad = showCounter || showEye ? "pr-24" : "pr-4";
  const leftPad = icon ? "pl-10" : "pl-4";
  const borderClass = error ? "border-red-500" : "border-gray-300";

  return (
    <div className="">
      <label className="block text-sm font-medium text-primary" htmlFor={name}>
        {label}{" "}
        {required && showRequiredOrOptional && (
          <span className="text-muted">{t("modal.required")}</span>
        )}
        {!required && showRequiredOrOptional && (
          <span className="text-muted">{t("modal.optional")}</span>
        )}
      </label>

      <div className="relative  shadow-md rounded-lg">
        {icon && (
          <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-500 pointer-events-none">
            {icon}
          </span>
        )}

        <input
          id={name}
          type={type === "password" && showPassword ? "text" : type}
          name={name}
          autoComplete="off"
          value={value}
          maxLength={maxLength}
          onChange={(e) => onChange(name, e.target.value)}
          onFocus={onFocus}
          placeholder={placeholder}
          required={required}
          max={max !== null ? max : undefined}
          className={`w-full appearance-none text-primary placeholder:text-muted border  rounded-md ${leftPad} h-12 ${rightPad} focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary shadow-sm ${additionalClass} !bg-white`}
        />

        {(showCounter || showEye) && (
          <div className="absolute inset-y-0 right-3 flex items-center gap-2">
            {showCounter && (
              <span className="text-gray-400 text-sm whitespace-nowrap">
                {value.length} / {maxLength}
              </span>
            )}
            {showEye && (
              <button
                type="button"
                className="text-gray-500"
                onClick={() => setShowPassword((v) => !v)}
              >
                {showPassword ? (
                  <EyeIcon className="w-5 h-5" />
                ) : (
                  <EyeSlashIcon className="w-5 h-5" />
                )}
              </button>
            )}
          </div>
        )}
      </div>

      {error && <p className="text-sm text-red-500">{error}</p>}
    </div>
  );
}
